(ns io.daskul.webapp.panel.events
  "Generic panel state events for slide-over panels.
   Manages open/close/mode/entity-id in re-frame db under [:ui :panel]."
  (:require
   [re-frame.core :as rf]))

(defn close-panel-db
  "Clear panel state from db. Reusable in product event handlers."
  [db]
  (-> db
      (assoc-in [:ui :panel :open?] false)
      (assoc-in [:ui :panel :mode] nil)
      (assoc-in [:ui :panel :entity-id] nil)))

(rf/reg-event-db
 ::open-panel
 (fn [db [_ mode entity-id]]
   (-> db
       (assoc-in [:ui :panel :open?] true)
       (assoc-in [:ui :panel :mode] mode)
       (assoc-in [:ui :panel :entity-id] entity-id))))

(rf/reg-event-db
 ::close-panel
 (fn [db _]
   (close-panel-db db)))
